// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"5e2be4c9","392":"0a3dcb49","405":"0543b761"}[chunkId] + ".chunk.css";
};